import {
    PROVIDER_EXPERIENCE_IS_LOADING,
    APPLY_PROVIDER_EXPERIENCE_FILTER,
    APPLY_PROVIDER_EXPERIENCE_FILTER_SUCCESS,
} from '../actionTypes';

export const applyProviderExperienceFilter = (payload: any) => ({
    type: APPLY_PROVIDER_EXPERIENCE_FILTER,
    payload
});

export const applyProviderExperienceFilterSuccess = (payload: any) => ({
    type: APPLY_PROVIDER_EXPERIENCE_FILTER_SUCCESS,
    payload
});

export const providerExperienceIsLoading = (payload: any) => ({
    type: PROVIDER_EXPERIENCE_IS_LOADING,
    payload
});
